import {Controller} from "stimulus"

export default class extends Controller {
  static get targets() {
    return ["dropArea", "hiddenInput"]
  }

  connect() {
    this.boundOnDragOver = this.onDragOver.bind(this)
    this.boundOnDragLeave = this.onDragLeave.bind(this)
    this.boundOnDrop = this.onDrop.bind(this)
    this.boundOnClick = this.onClick.bind(this)
    this.boundOnChange = this.onChange.bind(this)

    this.dropAreaTarget.addEventListener("dragover", this.boundOnDragOver)
    this.dropAreaTarget.addEventListener("dragleave", this.boundOnDragLeave)
    this.dropAreaTarget.addEventListener("drop", this.boundOnDrop)
    this.dropAreaTarget.addEventListener("click", this.boundOnClick)
    this.hiddenInputTarget.addEventListener("change", this.boundOnChange)


  }

  disconnect() {
    this.dropAreaTarget.removeEventListener("dragover", this.boundOnDragOver)
    this.dropAreaTarget.removeEventListener("dragleave", this.boundOnDragLeave)
    this.dropAreaTarget.removeEventListener("drop", this.boundOnDrop)
    this.dropAreaTarget.removeEventListener("click", this.boundOnClick)
    this.hiddenInputTarget.removeEventListener("change", this.boundOnChange)
  }

  onDragOver(e) {
    e.preventDefault()
    this.dropAreaTarget.classList.add("dropzone_over")
  }

  onDragLeave(e) {
    e.preventDefault()
    this.dropAreaTarget.classList.remove("dropzone_over")
  }

  onDrop(e) {
    e.preventDefault()
    this.processFiles(e.dataTransfer.files)
    this.dropAreaTarget.classList.remove("dropzone_over")
  }

  onClick(e) {
    e.preventDefault()
    this.hiddenInputTarget.click()
  }

  onChange(e) {
    e.preventDefault()
    this.processFiles(e.target.files)
  }

  processFiles(files) {
    if (files.length) {
      Array.prototype.forEach.call(files, (file) => {
        this.processFile(file)
      })
    }
  }

  processFile(file) {
    let fileInput = this.getOrAddInputField()
    fileInput.dataset.dropzone = "used"

    setTimeout(() => {
      // Create a data transfer object. Similar to what you get from a `drop` event as `event.dataTransfer`
      const dataTransfer = new DataTransfer()

      // Add your file to the file list of the object
      dataTransfer.items.add(file)

      // Save the file list to a new variable
      const fileList = dataTransfer.files

      // Set your input `files` to the file list
      fileInput.files = fileList

      // Trigger the change event
      fileInput.dispatchEvent(new Event("change"))
    }, 100)
  }

  getOrAddInputField() {
    const nestedFormElement = this.element.querySelector(
        '[data-controller="nested-form"]'
    )
    const controller = this.application.getControllerForElementAndIdentifier(
        nestedFormElement,
        "nested-form"
    )
    controller.addAssociation()

    // return the last (not hidden) input field on element
    let inputs = this.element.querySelectorAll('input[type="file"]:not([hidden])')
    return inputs[inputs.length - 1]

  }
}
